import React from 'react';
import './App.css';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import GamesShowcase from './components/GamesShowcase';
import Support from './components/Support';
import LegalDocumentation from './components/LegalDocumentation';
import Contacts from './components/Contacts';

function App() {
  return (
    <div className="App">
      <Navigation />
      
      <main className="App-main">
        <HeroSection />
        <GamesShowcase />
        <Support />
        <LegalDocumentation />
        <Contacts />
      </main>
      
      <footer className="App-footer">
        <p>&copy; {new Date().getFullYear()} BG5 L.L.C-FZ. All rights reserved.</p>
        <p className="App-footer-links">
          <a href="/privacy-policy.html">Privacy Policy</a>
        </p>
      </footer>
    </div>
  );
}

export default App;

